<div class="monitoring-company-selector">
    <div class="col-12 flex flex-column mt-3">
        <p class="title-4 mb-2">Selecciona la empresa de monitoreo que deseas usar para este servicio</p>
        <mat-form-field appearance="outline">
            <mat-label>Empresa de monitoreo<span class="asterisk">*</span></mat-label>
            <mat-select [formControl]="monitoringCompanyControl">
                <mat-option *ngIf="loading" disabled>
                    <i class="fas fa-spinner fa-spin mr-2"></i>Cargando empresas...
                </mat-option>
                <mat-option *ngFor="let company of monitoringCompanies; let i = index" [value]="company">
                    {{ i + 1 }} - {{ company.name }}
                </mat-option>
                <mat-option *ngIf="!loading && !monitoringCompanies.length" disabled>
                    No hay empresas de monitoreo disponibles
                </mat-option>
            </mat-select>
            <mat-error *ngIf="monitoringCompanyControl.errors?.required">
                {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
        </mat-form-field>
    </div>
</div>